export default __webpack_public_path__ + "static/circleImg-96d30f4de4df9513f6f4c5f807d1faee.png";